import { ComponentPropsWithoutRef, Dispatch, SetStateAction } from 'react';

import './InputAnimated.scss';

interface InputAnimatedProps extends Omit<ComponentPropsWithoutRef<'input'>, 'onChange'> {
  setState: Dispatch<SetStateAction<string>>;
  placeholder: string;
}

function InputAnimated({ className, placeholder, value, setState, ...rest }: InputAnimatedProps) {
  return (
    <div className={`custom-input-container ${className}`}>
      <input placeholder=" " value={value} onChange={e => setState(e.target.value)} {...rest} />
      <div className="placeholder">{placeholder}</div>
    </div>
  );
}

export default InputAnimated;
